export default __webpack_public_path__ + "static/logo-bc9fdd1ca6f83d4c4e09132b6e7a4f99.png";